import some from 'lodash/some';

export const canUnarchivePage = (operations: any): boolean => {
	return some(operations, { targetType: 'page', operation: 'archive' });
};

export const canDeletePage = (operations: any): boolean =>
	some(operations, { targetType: 'page', operation: 'delete' });
